<!--
  <div style="text-align: center; font-weight:normal;">
  <b>
    Delhi Airport Parking Services (P) Ltd.
  </b>
  <br />
  <b style="font-size: 90%;">
    Terminal 1D Parking
  </b>
  <br />
  <div style="font-size: 90%; padding-top: 6px;">
    IGIA Terminal T2,
    <br />
    New Delhi, New Delhi
    <br />
    Tel: 03-0000000 Fax: 03-0000001 Email: support@email.com
    <br />
    Gst No : 88888888
    <br />
    HSN/SAC No : 44444444
    <br />
    <div style="padding-top: 6px;">
      <b>
        OFFICIAL RECEIPT
      </b>
    </div>
  </div>
</div>
<table style="width: 100%; border-top: 1px solid gray; font-weight: normal; font-size:90%;">
  <tbody>
    <tr>
      <td style="width:60%">
        <div style="margin:6px; border: 1px solid gray; height: 80px; padding: 6px;">
          Customer: BARON-AVIATION
        </div>
      </td>
      <td style="vertical-align: top;">
        <table style="width:100%; text-align:right;">
          <tbody>
            <tr>
              <td style="padding-top: 12px;">
                Receipt No.
                <br />
                Issued On
              </td>
              <td>
                <div style="margin: 6px 6px 0px 6px; border: 1px solid gray; padding: 6px; font-size: 120%; text-align: left; vertical-align: middle; ">
                  <b>
                    R&D.CC1.00030562
                  </b>
                </div>
                <div style="margin: 0px 6px 6px 6px; border-left: 1px solid gray; border-right: 1px solid gray; border-bottom: 1px solid gray; padding: 6px; text-align: left; ">
                  21/06/2017 15:20:28
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</table>
<div style="padding: 6px;">
  <table style="text-align: center; font-weight: normal; width: 100%; border: 1px solid gray; font-size: 90%;">
    <tbody>
      <tr>
        <td style="vertical-align: top; border: 1px solid gray; padding:4px;">
          Item
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding:4px;">
          Passcode #
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding:4px;">
          Vehicle #
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding:4px;">
          Bay #
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding:4px; width: 21%;">
          Validity
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; width: 13%;">
          Parking
          <br />
          Fee (RS)
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; width: 13%;">
          CGST &amp; GSST
          <br />
          (RS)
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; width: 13%;">
          Amount
          <br />
          (RS)
        </td>
      </tr>
      <tr>
        <td style="vertical-align: top; border: 1px solid gray; padding:4px; text-align:left;">
          1
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
          6.234
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
          DL1C11212
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
          1245
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          01/01/2021 - 01/01/2021
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          1,441.05
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          208.95
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          1650.00
        </td>
      </tr>
      <tr>
        <td style="vertical-align: top; border: 1px solid gray; padding:4px; text-align:left;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          <b>
            Total
          </b>
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          1,441.05
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          208.95
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          1650.00
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div style="padding: 6px;">
  <table style="text-align: center; font-weight: normal; width: 100%; border: 1px solid gray; font-size: 90%;">
    <tbody>
      <tr>
        <td style="vertical-align: top; border: 1px solid gray; padding:4px;">
          Remarks
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding:4px; width: 21%;">
          Charges
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; width: 13%;">
          Fee
          <br />
          Fee (RS)
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; width: 13%;">
          CGST &amp; GSST
          <br />
          (RS)
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; width: 13%;">
          Amount
          <br />
          (RS)
        </td>
      </tr>
      <tr>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
          Parking Fee
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          0.00
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          0.00
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          0.00
        </td>
      </tr>
      <tr>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
          <b>
            Grand Total
          </b>
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          1,441.05
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          208.95
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          1650.00
        </td>
      </tr>
      <tr>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          <b>
            Credit b/f
          </b>
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          0.00
        </td>
      </tr>
      <tr>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: left;">
          Rounding Difference
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; text-align: right;">
          0.00
        </td>
      </tr>
    </tbody>
  </table>
  <table style="text-align: center; font-weight: normal; width: 100%; border: 1px solid gray; font-size: 90%; margin-top: 2px;">
    <tbody>
      <tr>
        <td style="vertical-align: top; border: 1px solid gray; padding:4px;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding:4px; width: 21%;">
          <b>
            Payment
          </b>
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; width: 13%;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; width: 13%;">
        </td>
        <td style="vertical-align: top; border: 1px solid gray; padding: 4px; width: 13%; text-align: right;">
          <b>
            3,300.00
          </b>
        </td>
      </tr>
    </tbody>
  </table>
  <table style="font-weight: normal; width: 100%;">
    <tbody>
      <tr>
        <td style="vertical-align: top;">
          <table style="font-weight: normal; width: 100%; border: 1px solid gray; font-size: 90%; margin-top: 2px;">
            <tbody>
              <tr>
                <td style="vertical-align: top; border: 1px solid gray; padding:4px; width: 21%;">
                  Cheque No.
                </td>
                <td style="vertical-align: top; border: 1px solid gray; padding: 4px;">
                </td>
              </tr>
              <tr>
                <td style="vertical-align: top; border: 1px solid gray; padding:4px; width: 21%;">
                  Credit Cart No.
                </td>
                <td style="vertical-align: top; border: 1px solid gray; padding: 4px;">
                </td>
              </tr>
              <tr>
                <td style="vertical-align: top; border: 1px solid gray; padding:4px; width: 21%;">
                  Bank Slip No.
                </td>
                <td style="vertical-align: top; border: 1px solid gray; padding: 4px;">
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="vertical-align: top; padding: 4px; width: 13%;">
        </td>
        <td style="vertical-align: top; padding: 4px; width: 13%;">
        </td>
        <td style="vertical-align: top; padding: 4px; width: 13%; text-align: right;">
        </td>
      </tr>
    </tbody>
  </table>
  <b style="font-size: 90%;">
    INDIAN RUPEE INCL. ALL TAX: THREE THOUSAND THREE HUNDRED ONLY
  </b>
  <table style="font-size:80%; width:100%;">
    <tbody>
      <tr>
        <td style="width: 60%;">
        </td>
        <td style="text-align:right;">
          <div style="">
            <div style="border-top: 2px solid black; margin-top:60px; text-align:center; font-weight:normal; padding: 6px;">
              <b>
                Delhi Airport Parking Services (P) Ltd.
              </b>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div style="width:100%; border-top: 1px solid gray; font-size:85%; padding-top:8px;">
    <b>
      This Official Receipt shall be valid upon clearance of cheques
    </b>
    <br />
    <span style="font-weight: normal;">
      Received by: (100) evoxen
    </span>
    <br />
    <span style="font-weight: normal;">
      This is a computer generated document and it does not require signature
    </span>
  </div>
</div>
-->

<div style="font-weight:100;">
  <b>DELHI AIRPORT PARKING SERVICES</b>
  <br />
  <b>MULTILEVEL CAR PARKING</b>
  <br />
  <b>IGI AIRPORT T3</b>
  <br />
  <b>NEW DELHI 110037</b>
  <br />
  <br />
  <br />
  GST # : 07AADCD3432B1ZA
  <br />
  SAC # :
  <br />
  <br />
  <br />
  RS.   : {{RS}}
  <br />
  CGST  : {{CGST}}
  <br />
  IGST  : {{IGST}}
  <br />
  NET   : {{NET}}
  <br />

  <br />
  <br />
  TYPE 	     : {{TYPE}}
  <br />
  SUBSCIBER # : {{SUBSCRIBER }}
  <br />
  PROFILE	     : {{PROFILE}}
  <br />
  VALIDITY     : {{VALIDITY}}
  <br />
</div>
